import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { Box, Card, Grid } from "@mui/material";

import { WebMapContext } from "../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../pages/sections/web-map/LoadWebMap";

const SidePanelMainWrapper = styled.div`
  color: black !important;
  font-weight: bold;
`;

export default function CurrentZoomLabel() {
    const { mapPlacement, mapZoomLevel } = useContext(WebMapContext);
    const { mapView, commonFilters } = useContext(LoadMapContext);

    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

    useEffect(() => {
        setIsCollapsed(mapView === null ? false : true);
        setIsSidePanelOpen(mapView === null ? isSidePanelOpen : false);
    }, [mapView]);

    useEffect(() => {
        commonFilters.country && setIsSidePanelOpen(!isCollapsed);
    }, [isCollapsed]);

    return (
        <SidePanelMainWrapper>
            <Grid
                container
                style={{
                    position: "fixed",
                    bottom: mapPlacement === 'right' ? "98px" : "110px",
                    ...(mapPlacement === 'right'
                        ? { right: '5px' }
                        : { left: '5px' }),
                    overflow: "auto",
                    maxHeight: "85vh",
                    width: "auto",
                    zIndex: 1,
                    borderRadius: '2px'
                }}
            >
                <Box
                    sx={{
                        width: 22,
                        height: 20,
                        backgroundColor: "#ffffff"
                    }}
                >
                    <Card variant="outlined" style={{ textAlign: "center", color: "#656565de", border: 0, fontSize: "15px" }}>
                        {mapZoomLevel}
                    </Card>
                </Box>
            </Grid>
        </SidePanelMainWrapper>
    );
}
